<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Stripe User</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'stripeUserId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'stripeUserId') || (field.name === 'stripeUserId' && editMode)"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="field.name === 'stripeUserId' && editMode" required>
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <button type="submit" class="procricket-btn">Save changes</button>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {StripeUser} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'EventEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        stripeUserId : this.$route.params.stripeUserId,
        stripeConfigurationId : this.$route.params.stripeConfigurationId,
        userId : this.$route.params.userId,
        stripeCustomerId : this.$route.params.stripeCustomerId
      },
      editMode: false,
      fields: [
        { name: "stripeUserId", label: "Stripe User Id" },
        { name: "stripeConfigurationId", label: "Stripe Configuration Id" },
        { name: "userId", label: "User Id" },
        { name: "stripeCustomerId", label: "Stripe Customer Id" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.stripeUserId) {
      this.editMode = true;
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new StripeUser(
          this.editedConfig.stripeUserId ,
          this.editedConfig.stripeConfigurationId ,
          this.editedConfig.userId ,
          this.editedConfig.stripeCustomerId
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateStripeUser(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'StripeUsers' });
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertStripeUser(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the /stripe page
          this.$router.push({ name: 'StripeUsers' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
